import BootstrapField from '../utility/BootstrapField';
// import moment from 'moment-timezone';
// import CloneDeep from 'lodash.clonedeep';
// import DeepDiff from 'deep-diff';
import IsEqual from 'lodash.isequal';

export default class PublicBanner {

    static get getTypes() {
        return [
            {
                text: "Blank",
                value: 0,
            },
            {
                text: "Info",
                value: 1,
            },
            {
                text: "Warning",
                value: 2,
            },
            {
                text: "Danger",
                value: 3,
            },
			{
                text: "Success",
                value: 4,
            },
        ]
    }

    constructor(data) {
        if (!data) {
            data = {};
        }

        Object.assign(this, {
            id: data.publicBannerId ? data.publicBannerId : (data.id || null),
            template: new BootstrapField({
                value: (data.template == null || data.template == undefined) ? null : data.template,
                require: true,
            }),
            content: new BootstrapField({
                value: data.content || "",
            }),
            contentFr: new BootstrapField({
                value: data.contentFr || "",
            }),
            updateTime: data.updateTime || null,
            isActive: new BootstrapField({
                value: data.isActive || 0,
                require: true,
            }),
        });
    }


    validate() {
		let flag = true;
		let errors = [];
		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							if (typeof obj[key][arrKey] != "function") {
								value[key].push(getRawValue(obj[key][arrKey]));
							}
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getRawValue(obj[key]);
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);

		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					} else {
						value[key] = getValue(obj[key]);
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}
}